import clsx from 'clsx';
import { type ReactNode } from 'react';
import { CheckIcon } from './CheckIcon';

export function Feature({ text, className }: { text: string | ReactNode; className?: string }) {
    return (
        <div className={clsx('flex flex-row items-center gap-x-2', className)}>
            <CheckIcon className='h-4 w-4 shrink-0' />
            <span className='leading-5'>{text}</span>
        </div>
    );
}
